import { Alert, Box, Card, CardContent, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Layout from '../../components/layouts/Layout';
import useUserRequest from '../../requests/UsersRequest';
import { AccountRoutes } from '../../routes/AccountRoutes';
import NewUserEditForm from '../../components/account/users/NewUserEditForm';
import Loader from '../../components/common/Loader';

const EditUser = ({ customer, accessLevel, accessType, errorHandler }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { getUserById } = useUserRequest();
  const getUserByIdRef = useRef(getUserById);
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [manageDedicatedNumbers, setManageDedicatedNumbers] = useState(false);

  useEffect(() => {
    if (!id) {
      navigate('/account/users');
      return;
    }

    let isMounted = true;

    const loadUser = async () => {
      try {
        setIsLoading(true);
        const userData = await getUserByIdRef.current(id, errorHandler);
        if (isMounted) {
          setUser(userData);
        }
      } catch (error) {
        if (isMounted) {
          console.error('Error loading user:', error);
          setError('Error loading user data');
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    loadUser();

    return () => {
      isMounted = false;
    };
  }, [id, navigate]); // Only depend on id and navigate

  const handleClose = (refresh = false) => {
    if (manageDedicatedNumbers) {
      setManageDedicatedNumbers(false);
    } else {
      navigate('/account/users');
    }
  };

  return (
    <Layout
      routes={AccountRoutes}
      title="User Profile"
      backButtonText={
        manageDedicatedNumbers ? 'Back to User' : 'Back to User List'
      }
      handleBackButton={handleClose}
      accessLevel={accessLevel}
      accessType={accessType}
      isHidden={!customer.hasCampaign}
    >
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Alert severity="error">{error}</Alert>
      ) : (
        <NewUserEditForm
          user={user}
          onClose={handleClose}
          errorHandler={errorHandler}
          accessLevel={accessLevel}
          accessType={accessType}
          manageDedicatedNumbers={manageDedicatedNumbers}
          setManageDedicatedNumbers={setManageDedicatedNumbers}
        />
      )}
    </Layout>
  );
};

export default EditUser;
